import Vue from 'vue'

export default {
    get(id) {
        return Vue.axios.get(`/modifier/${id}`)
    },
    list(params) {
        return Vue.axios.get(`/modifiers`, {params})
    },
    listConstructor(params) {
        return Vue.axios.get(`/modifiers/constructor`, {params})
    },
    massEdit(act, params){
        return Vue.axios.post(`/modifiers/mass-edit/${act}`, params)
    },
    listByCategory(params) {
        return Vue.axios.get(`/modifiers-by-category`, {params})
    },
    getCategoryList(params) {
        return Vue.axios.get(`/modifiers/categories`)
    },
    listGroups(params) {
        return Vue.axios.get(`/modifiers/group`, {params})
    },
    remove(id) {
        return Vue.axios.get(`/modifier/remove/${id}`)
    },
    update(id, data) {
        return Vue.axios.post(`/modifier/update/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    create(data) {
        return Vue.axios.post(`/modifier/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    addToConstructor(ids) {
        return Vue.axios.post(`/modifier/constructor/add`, ids)
    },
    getModifiersGroupConstructor(ids) {
        return Vue.axios.get(`/modifier-group/constructor`)
    },
    removeModifierGroup(id) {
        return Vue.axios.get(`/modifier-group/remove/${id}`)
    },
    updateConstructor(id, data) {
        return Vue.axios.post(`/modifier/constructor/update/${id}`, data)
    },
    updateModifiersGroupConstructor(id, data) {
        return Vue.axios.post(`/modifier-group/constructor/update/${id}`, data)
    },
    removeFromConstructor(id, data) {
        return Vue.axios.post(`/modifier/constructor/remove/${id}`, data)
    },
    createModifierGroup(params) {
        return Vue.axios.post(`/modifier-group/create`, params)
    },
    updateModifierGroup(params) {
        return Vue.axios.post(`/modifier-group/update`, params)
    },
    updateSortInModifierGroup(params) {
        return Vue.axios.post(`/modifier-group/update/modifiers-sort`, params)
    },
    updateSortInModifierGroups(params) {
        return Vue.axios.post(`/modifier-group/update/sort`, params)
    },
    updateModifiersGroupModifier(params) {
        return Vue.axios.post(`/modifier-group/update/modifiers`, params)
    },
    toggleModifierHide(params) {
        return Vue.axios.post(`/modifier-group/update/modifiers/hide`, params)
    },
}
